import {BaseModel} from '../../base/models/base-model.model';
import {ListString} from '../DTO/listString';
import {AggregationModel} from './aggregation.model';
import {AccountingModel} from './accounting.model';
import {UnitModel} from './unit.model';

export class ApplicationUserModel extends BaseModel {
  private _appId?: string;
  private _identityId?: string;
  private _managedCustomersAccounts?: any;
  private _managedCustomersSet?: any;
  private _aggregations?: Array<AggregationModel>;
  private _managedAccounting?: AccountingModel;
  private _managedUnits?: Array<UnitModel>;
  private _roles?: Array<string>;
  private _uida?: string;
  private _unit?: string;
  private _external?: boolean;
  private _name?: string;

  constructor(appId?: string, identityId?: string, managedCustomersAccounts?: any, managedCustomersSet?: any, aggregations?: Array<AggregationModel>, managedAccounting?: AccountingModel, managedUnits?: Array<UnitModel>, roles?: ListString, uida?: string, unit?: string, external?: boolean, name?: string) {
    super();
    this._appId = appId;
    this._identityId = identityId;
    this._managedCustomersAccounts = managedCustomersAccounts;
    this._managedCustomersSet = managedCustomersSet;
    this._aggregations = aggregations;
    this._managedAccounting = managedAccounting;
    this._managedUnits = managedUnits;
    this._roles = roles;
    this._uida = uida;
    this._unit = unit;
    this._external = external;
    this._name = name;
  }

  get external(): boolean {
    return this._external;
  }

  set external(value: boolean) {
    this._external = value;
  }

  get appId(): string {
    return this._appId;
  }

  set appId(value: string) {
    this._appId = value;
  }

  get identityId(): string {
    return this._identityId;
  }

  set identityId(value: string) {
    this._identityId = value;
  }

  get managedCustomersAccounts(): any {
    return this._managedCustomersAccounts;
  }

  set managedCustomersAccounts(value: any) {
    this._managedCustomersAccounts = value;
  }

  get managedCustomersSet(): any {
    return this._managedCustomersSet;
  }

  set managedCustomersSet(value: any) {
    this._managedCustomersSet = value;
  }

  get aggregations(): Array<AggregationModel> {
    return this._aggregations;
  }

  set aggregations(value: Array<AggregationModel>) {
    this._aggregations = value;
  }

  get managedAccounting(): AccountingModel {
    return this._managedAccounting;
  }

  set managedAccounting(value: AccountingModel) {
    this._managedAccounting = value;
  }

  get managedUnits(): Array<UnitModel> {
    return this._managedUnits;
  }

  set managedUnits(value: Array<UnitModel>) {
    this._managedUnits = value;
  }

  get roles(): ListString {
    return this._roles;
  }

  set roles(value: ListString) {
    this._roles = value;
  }

  get uida(): string {
    return this._uida;
  }

  set uida(value: string) {
    this._uida = value;
  }

  get unit(): string {
    return this._unit;
  }

  set unit(value: string) {
    this._unit = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }
}
